module.exports = __webpack_public_path__ + "static/media/dejo.3064c9ca.jpg";